/*
  CEREBRO · comportamiento propio sobre Dawn. Sin dependencias ni llamadas externas.
  Todo es idempotente (data-vf-ready) para sobrevivir a los repintados de Dawn y del editor.
*/
(function () {
  'use strict';

  var lang = document.documentElement.lang || 'es';
  var dayFormat;
  try {
    dayFormat = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'short' });
  } catch (e) {
    dayFormat = new Intl.DateTimeFormat('es', { day: 'numeric', month: 'short' });
  }

  function once(el) {
    if (el.dataset.vfReady) return false;
    el.dataset.vfReady = '1';
    return true;
  }

  function day(offset) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + offset);
    return d;
  }

  function label(d) {
    return dayFormat.format(d).replace('.', '');
  }

  function range(a, b) {
    if (a.getTime() === b.getTime()) return label(a);
    if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + label(b);
    return label(a) + ' – ' + label(b);
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* Plazos de entrega: fechas calculadas con los días reales configurados. */
  function initShipping(root) {
    root.querySelectorAll('[data-vf-ship]').forEach(function (el) {
      var prepMin = parseInt(el.dataset.prepMin, 10) || 0;
      var prepMax = Math.max(parseInt(el.dataset.prepMax, 10) || 0, prepMin);
      var transitMax = parseInt(el.dataset.transitMax, 10) || 0;
      var transitMin = Math.min(parseInt(el.dataset.transitMin, 10) || 0, transitMax);
      var slots = el.querySelectorAll('[data-vf-ship-date]');
      if (slots.length < 3 || transitMax <= 0) return;
      slots[0].textContent = label(day(0));
      slots[1].textContent = range(day(prepMin), day(prepMax));
      slots[2].textContent = range(day(prepMin + transitMin), day(prepMax + transitMax));
    });
  }

  /* Botón fijo: aparece cuando el botón de compra principal sale por arriba. */
  function initSticky(root) {
    root.querySelectorAll('[data-vf-sticky]').forEach(function (bar) {
      if (!once(bar)) return;
      var target = document.getElementById(bar.dataset.target);
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          bar.inert = !show;
        });
      }).observe(target);
    });
  }

  /* Contador de oferta: fecha fin real; al llegar a cero, la sección desaparece. */
  function initCountdown(root) {
    root.querySelectorAll('[data-vf-countdown]').forEach(function (el) {
      if (!once(el)) return;
      var end = parseInt(el.dataset.end, 10) * 1000;
      var host = el.closest('.shopify-section') || el;
      if (!end) {
        host.hidden = true;
        return;
      }
      var parts = {
        d: el.querySelector('[data-d]'),
        h: el.querySelector('[data-h]'),
        m: el.querySelector('[data-m]'),
        s: el.querySelector('[data-s]'),
      };
      var timer;
      function tick() {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          host.hidden = true;
          clearInterval(timer);
          return;
        }
        parts.d.textContent = pad(Math.floor(left / 86400));
        parts.h.textContent = pad(Math.floor((left % 86400) / 3600));
        parts.m.textContent = pad(Math.floor((left % 3600) / 60));
        parts.s.textContent = pad(left % 60);
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* Contador de reserva del carrito (desactivado por defecto; solo si la reserva es real). */
  function initCartCountdown(root) {
    root.querySelectorAll('[data-vf-cart-countdown]').forEach(function (el) {
      if (!once(el)) return;
      var total = (parseInt(el.dataset.minutes, 10) || 10) * 60;
      var key = 'vfCartReservationStart';
      var start;
      try {
        start = parseInt(sessionStorage.getItem(key), 10);
        if (!start) {
          start = Date.now();
          sessionStorage.setItem(key, String(start));
        }
      } catch (e) {
        start = Date.now();
      }
      var template = el.dataset.text || '[tiempo]';
      var timer;
      function tick() {
        var left = total - Math.floor((Date.now() - start) / 1000);
        if (left <= 0) {
          el.textContent = '';
          clearInterval(timer);
          return;
        }
        el.textContent = template.replace('[tiempo]', Math.floor(left / 60) + ':' + pad(left % 60));
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  /* Antes / después. */
  function initBeforeAfter(root) {
    root.querySelectorAll('[data-vf-ba]').forEach(function (el) {
      if (!once(el)) return;
      var input = el.querySelector('input[type="range"]');
      if (!input) return;
      input.addEventListener('input', function () {
        el.style.setProperty('--vf-pos', input.value + '%');
      });
    });
  }

  /* Carrusel con flechas. */
  function initSliders(root) {
    root.querySelectorAll('[data-vf-slider]').forEach(function (el) {
      if (!once(el)) return;
      var track = el.querySelector('[data-vf-track]');
      if (!track) return;
      function step(direction) {
        var slide = track.firstElementChild;
        var width = slide ? slide.getBoundingClientRect().width + 24 : track.clientWidth;
        track.scrollBy({ left: direction * width, behavior: 'smooth' });
      }
      var prev = el.querySelector('[data-vf-prev]');
      var next = el.querySelector('[data-vf-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  /* Diapositivas de la portada. */
  function initHero(root) {
    root.querySelectorAll('[data-vf-hero]').forEach(function (el) {
      if (!once(el)) return;
      var slides = el.querySelectorAll('[data-vf-slide]');
      var dots = el.querySelectorAll('[data-vf-dot]');
      if (slides.length < 2) return;
      var current = 0;
      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { show(parseInt(dot.dataset.vfDot, 10) || 0); });
      });
      var seconds = parseInt(el.dataset.autoplay, 10) || 0;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (seconds > 0 && !reduce) {
        setInterval(function () { show(current + 1); }, seconds * 1000);
      }
    });
  }

  function init(root) {
    root = root || document;
    initShipping(root);
    initSticky(root);
    initCountdown(root);
    initCartCountdown(root);
    initBeforeAfter(root);
    initSliders(root);
    initHero(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Dawn repinta trozos (variantes, carrito): se vuelve a pasar sobre lo nuevo. */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      init(document);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
